var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L20 20L16 24",
    stroke: "#5D5D5D",
    strokeWidth: 1.60662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V29",
    stroke: "#5D5D5D",
    strokeWidth: 1.60662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3904 26.3895C29.3658 25.8578 30.1363 25.0164 30.5803 23.9981C31.0244 22.9799 31.1167 21.8427 30.8427 20.7662C30.5686 19.6896 29.9439 18.735 29.0671 18.0529C28.1903 17.3709 27.1113 17.0002 26.0005 16.9995H24.7405C24.4378 15.8287 23.8736 14.7418 23.0904 13.8205C22.3072 12.8991 21.3253 12.1673 20.2185 11.6801C19.1118 11.1929 17.909 10.9629 16.7006 11.0074C15.4921 11.0519 14.3095 11.3698 13.2416 11.9372C12.1737 12.5045 11.2484 13.3066 10.5351 14.2831C9.82178 15.2596 9.33914 16.385 9.12343 17.5749C8.90772 18.7647 8.96455 19.988 9.28966 21.1528C9.61477 22.3175 10.1997 23.3934 11.0004 24.2995",
    stroke: "#5D5D5D",
    strokeWidth: 1.60662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L20 20L16 24",
    stroke: "#5D5D5D",
    strokeWidth: 1.60662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.a42b5b432ce391cd23bd7cf004920aca.svg";
export { ForwardRef as ReactComponent };